import { render } from "./Welcome.vue?vue&type=template&id=00edeb8c"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__